import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { MenuNode } from '../../../classes/MenuNode';
import { BaseSensor } from '../../../classes/BaseSensor';
@Component({
  selector: 'app-idle',
  templateUrl: './idle.component.html',
  styleUrls: ['./idle.component.scss']
})
export class IdleComponent implements OnInit {
	
	
	tempSensor:BaseSensor=undefined;
	pressureSensor:BaseSensor=undefined;
	eventSubscription : any = undefined;
	
	s():string{
		return this.pressureSensor.getCurrentValue()+"";
	}

	b():string{
		return this.tempSensor.getCurrentValue()+"";
	}

	unit():string{
		return this.tempSensor.getRawUnit();
	}

	constructor(
		private menuService:MenuService, 
		private ioService:DataIoService,
		private navBarService: NavBarService,
		private iconBarService: IconBarService
		) {

	}
	init():void{
		this.tempSensor = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp');
		this.pressureSensor = this.ioService.deviceInfo().getScale('waterpressure');
		this.navBarService.disableAll();
		this.navBarService.on('pressure');
		if(this.isLocked()){
			this.navBarService.on('locked');
		}
		this.iconBarService.enable();
	}

    isLocked(){
        return this.ioService.getDeviceInfo().getValue('buttonlock') == 'on';
    }


	ngOnInit() {
		this.init();
		//this.device
		console.log("OnInit on BaseDisplay called on Node: "+this.menuService.getCurrentNode().getIdentifier());
		this.eventSubscription = this.ioService.inputs.events$.subscribe( 
			(evt) => {
				if(evt == 'back'){
					this.menuService.goto('dashboard');
				}
				if(evt == 'menu'){
					this.menuService.goto('dashboard');
				}
			}
		);
	}


	ngOnDestroy(){
		this.navBarService.off('pressure');
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
		console.log("OnDestroy on BaseDisplay called on Node: "+this.menuService.getCurrentNode().getIdentifier());
	}
}
